import styled from 'styled-components'

export const AnimatedError = styled.div`
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 1rem;
    background-color: #ffe0e0;
    color: #a10000;
    border: 1px solid #ffaaaa;
    border-radius: 8px;
    font-weight: 500;
    text-align: center;
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`
